import React, { useState } from 'react';
import { PencilSquareIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const TechDetails = ({ jobCard, updateJobCard }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedJobCard, setEditedJobCard] = useState({ ...jobCard });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedJobCard((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = () => {
    updateJobCard(editedJobCard);
    setIsEditing(false);
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4 pb-3 border-b-2 border-gray-200">
        <h2 className="text-xl font-black text-gray-800">Diagnosis Report</h2>
        {isEditing ? (
          <button
            onClick={handleSave}
            className="flex items-center px-4 py-2 bg-gradient-to-r from-green-600 to-green-700 text-white font-bold rounded-xl hover:from-green-700 hover:to-green-800 transition-all shadow-lg"
          >
            <CheckCircleIcon className="h-5 w-5 mr-2" />
            Save Changes
          </button>
        ) : (
          <button
            onClick={() => setIsEditing(true)}
            className="flex items-center px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg"
          >
            <PencilSquareIcon className="h-5 w-5 mr-2" />
            Edit
          </button>
        )}
      </div>

      {/* Form Fields */}
      <div className="space-y-4">
        {/* Customer Complaint */}
        <div>
          <label className="block text-xs font-bold text-gray-700 mb-2">Customer Complaint</label>
          {isEditing ? (
            <textarea
              name="ownerRequest"
              value={editedJobCard?.ownerRequest || ''}
              onChange={handleInputChange}
              rows={3}
              className="w-full px-3 py-2 border-2 border-gray-300 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all text-sm"
              placeholder="Enter customer complaint or request"
            />
          ) : (
            <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
              <p className="text-sm text-gray-800">{jobCard?.ownerRequest || 'No complaint recorded'}</p>
            </div>
          )}
        </div>

        {/* Technical Diagnosis */}
        <div>
          <label className="block text-xs font-bold text-gray-700 mb-2">Technical Diagnosis</label>
          {isEditing ? (
            <textarea
              name="technicianObservation"
              value={editedJobCard?.technicianObservation || ''}
              onChange={handleInputChange}
              rows={3}
              className="w-full px-3 py-2 border-2 border-gray-300 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all text-sm"
              placeholder="Enter technician's diagnosis and observations"
            />
          ) : (
            <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
              <p className="text-sm text-gray-800">{jobCard?.technicianObservation || 'No diagnosis recorded'}</p>
            </div>
          )}
        </div>

        {/* Work Required */}
        <div>
          <label className="block text-xs font-bold text-gray-700 mb-2">Work Required</label>
          {isEditing ? (
            <textarea
              name="workRequired"
              value={editedJobCard?.workRequired || ''}
              onChange={handleInputChange}
              rows={3}
              className="w-full px-3 py-2 border-2 border-gray-300 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all text-sm"
              placeholder="Describe work that needs to be done"
            />
          ) : (
            <div className="p-3 bg-indigo-50 rounded-lg border border-indigo-200">
              <p className="text-sm text-gray-800">{jobCard?.workRequired || 'No work description'}</p>
            </div>
          )}
        </div>

        {/* Additional Observations */}
        <div>
          <label className="block text-xs font-bold text-gray-700 mb-2">Additional Observations</label>
          <textarea
            name="additionalObservations"
            value={editedJobCard?.additionalObservations || ''}
            onChange={handleInputChange}
            rows={3}
            className={`w-full px-3 py-2 border-2 rounded-xl transition-all text-sm ${
              isEditing
                ? 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200'
                : 'border-gray-200 bg-gray-50'
            }`}
            placeholder="Add any additional observations or notes"
            disabled={!isEditing}
          />
        </div>
      </div>
    </div>
  );
};

export default TechDetails;
